<script setup lang="ts"></script>

<template>
  <p class="text-12">
    <slot></slot>
  </p>
</template>
